import { DURUM_ETIKETI, type GorevDurumu, type Koordinat } from '../api/gorev';

/**
 * GÖREV EKRANLARININ PAYLAŞILAN PARÇALARI.
 *
 * `Gorev.tsx` ile `GorevRaporlari.tsx` durum rozetini paylaşıyor; birinin
 * içinde bırakılsaydı SÖZLEŞME §17'deki döngü üçüncü kez oluşurdu.
 *
 * `VARSAYILAN_MERKEZ` de burada: `HaritaTuvali` ona ihtiyaç duyuyor ve
 * `HaritaNoktasi` tuvali tembel yüklüyor — sabit orada kalsaydı iki modül
 * birbirine bağlanırdı.
 */

const DURUM_BICIMI: Record<GorevDurumu, string> = {
  planlandi: 'bg-slate-100 text-slate-600 ring-slate-200',
  basladi: 'bg-sky-50 text-sky-700 ring-sky-200',
  tamamlandi: 'bg-emerald-50 text-emerald-700 ring-emerald-200',
  iptal: 'bg-slate-50 text-slate-500 ring-slate-200',
  devredildi: 'bg-amber-50 text-amber-800 ring-amber-200',
};

export function GorevDurumRozeti({ durum }: { durum: GorevDurumu }) {
  return (
    <span
      className={`whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset ${DURUM_BICIMI[durum]}`}
    >
      {DURUM_ETIKETI[durum]}
    </span>
  );
}

/** Alanya belediye binası — harita ilk açılışta buraya odaklanır. */
export const VARSAYILAN_MERKEZ: Koordinat = { enlem: 36.5444, boylam: 31.9971 };
